import React from 'react'
import { PropsWithMetaData } from '../../types'

interface NavigationAnchorProps {
  title: string
  href: string
  icon?: React.ReactElement
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void
  className?: string
  style?: React.CSSProperties
}

export function NavigationAnchor (props: PropsWithMetaData<NavigationAnchorProps>): React.JSX.Element {
  const { title, icon, href, metadata, ...rest } = props
  return (
    <div className={'nav-link-container'}>
      { icon && (<span> {icon} </span>) }
      <a href={href} {...rest} {...metadata}> {title} </a>
    </div>
  )
}

export default NavigationAnchor
